import * as actionTypes from "./securityactionstypes";
import securityService from "../services/securityservice";
import * as appActions from "./appactions";
import sharedGlobals from "../sharedglobals";
import * as appConstants from "../overrides/appconstants";
// import {persistor} from "../store/store";

export const setUserSession = (userSession) => {
  return {
    type: actionTypes.SET_USER_SESSION,
    payload: userSession,
  };
};
export const checkAccess = (checkAccessOptions) => {
  /*checkaccessoption{"
      {
        pageMenuId,
        additionalMenuIds=[],
        showLogin=true, 
        requireAllMenus=false
      }
  */
    return async function (dispatch, state) {
    let {pageMenuId,additionalMenuIds,showLogin, requireAllMenus}=
    {
      pageMenuId:null,
      additionalMenuIds:null,
      showLogin:true,
      requireAllMenus:null,
      ...checkAccessOptions
    };
    console.log('MICORE checkAccess')
    let currentState=getState(state());   
    let userSession=currentState.userSession;
    console.log('userSession',userSession);
    let isAuthenticated=userSession!=null;
    sharedGlobals.sessionToken=securityService.getAuthToken();
    if(isAuthenticated==false&&sharedGlobals.sessionToken!=null){
      try{
          let userSessionResult=await securityService.getUserSessionByToken();
          if(!userSessionResult.hasErrors){
            isAuthenticated=true;
            userSession=userSessionResult.result.userSession;
            dispatch(setUserSession(userSession));
          }
      }catch(e){
        //check exception for 401 , if not 401 throw exception
        if(!(e.status&&e.status==401)){
            throw 'getUserssion failed';
        }
      }       
    }
    let hasAccess=isAuthenticated;
    if(isAuthenticated&&pageMenuId!=null&&pageMenuId!=''){
        let menusToCheck=[pageMenuId];
        if(additionalMenuIds){
          menusToCheck.push(...additionalMenuIds);
        }

        hasAccess=securityService.hasMenus(userSession.menus,menusToCheck,requireAllMenus);
   
      }

    //if system not sso redirect to sso
    if(!hasAccess&&showLogin&&appConstants.SYSTEM_ID!=1){
      //alert('i am about to be purged')
      // persistor.purge()
      // .then(() => {
      // return persistor.flush()
      // })
      // .then(() => {
      // persistor.pause()
      // })
   //   await persistor.flush();
      window.location.href=sharedGlobals.appUrls.ssoUrl+'login?pageId='+pageMenuId;
    }
    return Promise.resolve(hasAccess);
    
  };
};
export const redirectToPage = (menuId) => {
    return async function (dispatch, state) {
      console.log('MICORE redirectToPage')
      let currentState=getState(state());   
      let systemurl=securityService.getSystemUrl(currentState.userSession.menus, menuId)
        +'ssoredirecthandler?authToken='+securityService.getAuthToken()
      if(menuId){
        systemurl+='&pageId='+menuId;
      }
      window.location.href=systemurl;
    }
  };
  export const handlessoRedirect = (pageId,authToken) => {
    return async function (dispatch, state) {
      console.log('MICORE handlessoRedirect')
      securityService.setAuthCookie(authToken);
      if(!(await dispatch(checkAccess({pageMenuId:pageId})))){
        return Promise.resolve(null);
      }
      let currentState=getState(state()); 
      let url='/dashboard';
      if(!(pageId==''||pageId==null)){      
          let menu=currentState.userSession.menus.find(p=>p.menuId==pageId);
        //  if(menu.menuType==3){
            if(!(menu.url==null||menu.url=='')){
              url="/"+menu.url;
            }       
        //  }
        //   dispatch(securityActions.redirectToPage(pageMenuId));
      }
      return Promise.resolve(url);
    }
  };
  export const getUserSession = () => {

    return async function (dispatch, state) {  

        return state().securityReducer.userSession

  }

};  
const getState = (state) => {
  return state.securityReducer;
};
